import { useState } from "react";
import { useMapEvents } from "react-leaflet";
import { LocateFixed } from "lucide-react";
import { toast } from "sonner";

export function MapEvents({ onView, onCursor, onClick }) {
  useMapEvents({
    moveend: (e) => { const m = e.target; const c = m.getCenter(); const b = m.getBounds(); onView?.({ center: [c.lat, c.lng], zoom: m.getZoom(), bounds: [[b.getSouth(), b.getWest()], [b.getNorth(), b.getEast()]] }); },
    click: (e) => onClick?.([e.latlng.lat, e.latlng.lng]),
    mousemove: (e) => onCursor?.([e.latlng.lat, e.latlng.lng]),
    mouseout: () => onCursor?.(null),
  });
  return null;
}

export function parseCoords(text) {
  const m = text.trim().replace(/[°NnEe]/g, "").match(/^\s*(-?\d+(?:\.\d+)?)\s*[, ]\s*(-?\d+(?:\.\d+)?)\s*$/);
  if (!m) return null;
  const lat = Number(m[1]), lng = Number(m[2]);
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  return [lat, lng];
}

export function CoordinateBar({ cursor, view, onJump }) {
  const [text, setText] = useState("");
  const jump = (e) => {
    e.preventDefault();
    const c = parseCoords(text);
    if (!c) return toast.error("Enter coordinates as lat, lng — e.g. 21.2514, 81.6296");
    onJump(c);
  };
  const shown = cursor || view?.center;
  return (
    <div data-testid="coordinate-bar" className="glass rounded-full h-10 flex items-center shadow-lg pl-4 pr-1 gap-3 text-xs font-mono">
      <span data-testid="cursor-coords" className="min-w-[170px] text-muted-foreground" title={cursor ? "Cursor position" : "Map centre"}>
        {shown ? `${shown[0].toFixed(5)}° N, ${shown[1].toFixed(5)}° E` : "—"}{!cursor && shown ? " (centre)" : ""}{view ? ` · z${view.zoom.toFixed(0)}` : ""}
      </span>
      <form onSubmit={jump} className="flex items-center gap-1">
        <input data-testid="coordinate-jump-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="lat, lng" className="h-8 w-36 bg-transparent border-l pl-3 outline-none text-xs" />
        <button type="submit" data-testid="coordinate-jump-button" aria-label="Jump to coordinates" className="h-8 w-8 rounded-full grid place-items-center bg-emerald-900 text-white dark:bg-emerald-500 dark:text-slate-950"><LocateFixed size={14} /></button>
      </form>
    </div>
  );
}
